import React from "react"
import clsx from "clsx"
import { useTranslation } from "react-i18next"

import { ModalDialog } from "components/Elements/ModalDialog"
import { QRCodeScanner } from "components/Elements/QRCodeScanner"

type QRCodeModalProps = {
	onQRCodeScanned: (data: string) => void
	isOpen: boolean
	closeModal: () => void
}

export const QRCodeModal: React.FC<QRCodeModalProps> = ({
	onQRCodeScanned,
	isOpen,
	closeModal,
}) => {
	const { t } = useTranslation()

	return (
		<ModalDialog
			isOpen={isOpen}
			closeModal={closeModal}
			className={clsx("max-w-3xl")}
			title={t("searchBike.scanTitle", { ns: "bike" })}
		>
			<QRCodeScanner onFound={onQRCodeScanned} classname="p-4" />
		</ModalDialog>
	)
}
